module.exports = __webpack_public_path__ + "media/images/social-icons/pinterest-white-eb6f19924ea40c66238e7ba36ffff1ff.svg";